<template>
  <div v-if="list && list.length">
    <div class="product" v-for="(item, index) of list">
      <!-- 单商品：样式与之前一致 -->
      <div class="flex-ac productitem" v-if="item.goodsList.length == 1">
        <img class="img" v-lazy="item.goodsList[0].img_path" alt="" />
        <div class="ml7 flex-1" style="min-height: 0.8rem">
          <p class="f13 name ell-over-1">{{ item.goodsList[0].name }}</p>
          <p class="f11 spec color-6C flex-js-ac">
            <span>{{ item.goodsList[0].spec }}</span>
            <span>X{{ item.goodsList[0].num }}</span>
          </p>
        </div>
      </div>
      <!-- 多商品：横向平铺商品图 + 共N件标签 -->
      <div class="goodsList_wrap" v-else>
        <div class="goodsList_row">
          <img
            class="goodsList_img"
            v-for="(goodsitem, gindex) of item.goodsList"
            :key="gindex"
            v-lazy="goodsitem.img_path"
            alt=""
          />
        </div>
        <div class="goodsList_count_tag">共{{ goodsTotalNum(item) }}件</div>
      </div>
      <div class="giftproduct">
        <p class="f14">
          <b>选择赠品：</b>
          (可选择{{ item.buygiftnum }}个)您已选择
          <span class="color-FC0324">{{ item.choosegiftnum }}</span>
          个赠品
        </p>
        <div
          class="flex-ac giftproductitem"
          v-for="giftitem of item.buygiftlist"
          :id="giftitem.itemid"
        >
          <img class="img" v-lazy="giftitem.img_path" alt="" />
          <div class="ml7 flex-1" style="min-height: 0.6rem" :num="giftitem.num">
            <p class="f13 name ell-over-1">{{ giftitem.name }}</p>
            <p class="f11 spec color-6C flex-js-ac">{{ giftitem.spec }}</p>
            <van-stepper
              :long-press="false"
              integer
              class="goods_stepper"
              :min="0"
              :max="Number(giftitem.limitNum) || item.buygiftnum"
              :disabled="giftitem.showChangeEntry != '1'"
              :disable-plus="item.buygiftnum <= item.choosegiftnum || item.buygiftlist.length == 1"
              :disable-minus="item.buygiftlist.length == 1"
              disable-input
              v-model="giftitem.num"
              @change="changeHandle(index)"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="height: 0.84rem"></div>
    <footer class="flex-ac footerIOS">
      <div style="padding: 0.05rem 0">
        <div
          class="sureBtn"
          :class="{ graySureBtn: disabledSubmit || submitting }"
          @click="submit"
        >确定</div>
      </div>
    </footer>
  </div>
</template>

<script>
import { fenxiang, unencryption } from '../../assets/common/js/config'

export default {
  name: 'freeGiftZone_buyGift',
  data() {
    return {
      disabledSubmit: true,
      submitting: false, // 校验/提交防连点标志（校验期间按钮置灰）
      list: []
    }
  },
  mounted() {
    fenxiang({ path: 'freegiftzone_buygift' })
    this.getData()
  },
  methods: {
    getData() {
      this.list = []
      if (localStorage.getItem('shopConfirmResult')) {
        var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
        this.list =
          shopConfirmResult.buygiftrule && shopConfirmResult.buygiftrule.ruleList
            ? shopConfirmResult.buygiftrule.ruleList
            : []
        this.list.map((item) => {
          if (!item.choosegiftnum) item.choosegiftnum = 0
          /**规则对象归一化：无 goodsList 时用平铺字段构造（兼容旧缓存）*/
          if (!item.goodsList || !item.goodsList.length) {
            item.goodsList = [
              {
                itemid: item.itemid,
                name: item.name,
                num: item.num,
                spec: item.spec,
                img_path: item.img_path
              }
            ]
          }
          /**规则级 itemid 统一取 goodsList 各 itemid 逗号拼接串（后端约定规则级 itemid 即 goodsList[0] 的 itemid） */
          if (item.goodsList.length) {
            item.itemid = item.goodsList.map((g) => g.itemid).join(',')
          }
          /**origoodsId 与规则级 itemid 同源（均已归一化为 goodsList 拼接串） */
          item.origoodsId = item.itemid
          item.buygiftlist.map((giftitem) => {
            if (!giftitem.num) giftitem.num = 0
          })
        })
        console.log(this.list)
        this.$forceUpdate()
        this.$nextTick(() => {
          if (this.$route.query.itemid) {
            let giftOffsetTop = document.getElementById(this.$route.query.itemid).offsetTop
            document.body.scrollTop = giftOffsetTop
          }
          this.graySubmitBtn()
        })
      }
    },
    changeHandle(index) {
      console.log(this.list[index])
      this.list[index].choosegiftnum = 0
      this.list[index].buygiftlist.map((giftitem) => {
        this.list[index].choosegiftnum += giftitem.num
      })
      this.graySubmitBtn()
      this.$forceUpdate()
    },
    /**计算规则下所有正品商品的购买数量总和（共N件）*/
    goodsTotalNum(item) {
      let total = 0
      ;(item.goodsList || []).map((goodsitem) => {
        total += Number(goodsitem.num || 0)
      })
      return total
    },
    graySubmitBtn() {
      let temp = 0
      this.list.map((item) => {
        if (item.choosegiftnum && item.choosegiftnum != item.buygiftnum) {
          /**未选满时若所有赠品均已达到库存上限（库存总和不足）则允许提交 */
          let canadd = false
          item.buygiftlist.map((giftitem) => {
            if (!giftitem.limitNum || !giftitem.num || giftitem.num < Number(giftitem.limitNum)) {
              canadd = true
            }
          })
          if (canadd) temp = 1
        }
      })
      this.disabledSubmit = temp == 1 ? true : false
    },
    /**确定：先调 checkbuygiftnum 校验赠品，通过后才写缓存回确认订单页 */
    submit() {
      if (this.disabledSubmit || this.submitting) {
        return
      }
      /**组装校验参数：规则与已选赠品同序一一对应；未选赠品时空字符串占位 */
      const buygiftruleids = []
      const buygiftlist = []
      this.list.map((item) => {
        buygiftruleids.push({ ruleid: item.ruleid })
        const itemids = []
        const nums = []
        item.buygiftlist.map((giftitem) => {
          if (giftitem.num > 0) {
            itemids.push(giftitem.itemid)
            nums.push(giftitem.num)
          }
        })
        buygiftlist.push({
          itemid: itemids.join(','), // 赠品itemid逗号拼接
          num: nums.join(',') // 赠品数量逗号拼接，与 itemmid 一一对应
        })
      })
      this.submitting = true
      this.$customRequestAjax
        .post(this.$ajax.checkBuygiftNum_URL, {
          buygiftruleids: JSON.stringify(buygiftruleids),
          buygiftlist: JSON.stringify(buygiftlist)
        })  
        .then((res) => {
          this.submitting = false
          if (res.data.code == 200) {
            this.doSubmit()
          } else {
            this.$toast(res.data.msg || '赠品校验未通过')
          }
        })
        .catch(() => {
          this.submitting = false
          this.$toast('网络异常，请稍后重试')
        })
    },
    /**校验通过：写缓存并返回确认订单页（原提交逻辑） */
    doSubmit() {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.buygiftrule.ruleList = this.list
      shopConfirmResult.buygiftlist = [] // 买赠活动说选赠品集合
      shopConfirmResult.buygiftlist_submit = [] // 买赠所需赠品集合（提交下单数据）
      shopConfirmResult.buygiftorigoods = [] // 买赠原商品集合
      this.list.map((item) => {
        item.buygiftlist.map((giftitem) => {
          if (giftitem.num > 0) {
            // isbuygift|isgolist 前端自建参数
            giftitem.isbuygift = 1
            if (item.buygiftlist.length > 1) giftitem.isgolist = 1
            shopConfirmResult.buygiftlist.push(giftitem)
            shopConfirmResult.buygiftlist_submit.push({
              itemid: giftitem.itemid,
              num: giftitem.num
            })
            shopConfirmResult.buygiftorigoods.push({
              itemid: item.origoodsId
            })
          }
        })
      })
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.$router.replace({
        path: unencryption(this.$route.query.path)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.product {
  padding: 0.15rem 0.1rem;
  margin: 0.1rem;
  border-radius: 0.08rem;
  background: #ffffff;
}
.goodsList_wrap {
  text-align: center;
  display: flex;
  .goodsList_row {
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    text-align: left;
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
    -ms-overflow-style: none;
    .goodsList_img {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 0.04rem;
      flex-shrink: 0;
      margin-right: 0.08rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .goodsList_count_tag {
    display: inline-block;
    margin-top: 0.08rem;
    padding: 0.02rem 0.12rem;
    font-size: 0.12rem;
    line-height: 0.18rem;
    border-radius: 0.1rem;
  }
}
.giftproduct {
  background: #f4f6f7;
  padding: 0.1rem;
  border-radius: 0.04rem;
  margin-top: 0.1rem;
  > p {
    color: #333333;
  }
  .giftproductitem {
    margin-top: 0.1rem;
    .img {
      width: 0.6rem;
      height: 0.6rem;
    }
  }
}
.img {
  width: 0.8rem;
  height: 0.8rem;
}
.ml7 {
  margin-left: 0.07rem;
}
.name {
  color: #292929;
}
.spec {
  color: #6c6c6c;
  margin-top: 0.05rem;
}
.goods_stepper {
  float: right;
}
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 2px solid #dfdfdf;
  background: white;
  width: 100%;
  min-height: 0.48rem;
  justify-content: flex-end;
  .sureBtn {
    width: 1.12rem;
    height: 0.38rem;
    background: linear-gradient(90deg, #fc0324 0%, #ff144f 100%);
    font-size: 0.16rem;
    text-align: center;
    line-height: 0.38rem;
    border-radius: 0.19rem;
    margin-right: 0.1rem;
    color: white;
    &.graySureBtn {
      opacity: 0.7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopcart/freeGiftZone_buyGift.vue